import { Modal } from "antd";
import styled from "styled-components";

export const StyledModalWrapper = styled(Modal)`
  .ant-modal-header {
    border-radius: 2px;
    background-color: #134076;
    margin: 20px 20px 0px 20px; 
    padding: 4px 10px;
    .ant-modal-title {
      color: white;
      font-size: 16px;
    }
  }
  .ant-modal-content {
    border-radius: 8px;
    padding: 0;
    overflow: hidden;
    .ant-modal-close{
      color: white;
      top: 20px;
      right: 20px;
    }
  }
  .ant-modal-footer {
    display: flex;
    gap: 16px;
    padding: 0 20px 20px 20px;
    border-top: none;
  }
`;
